import type { ReactNode } from "react";

const s = { width: 20, height: 20, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.7, strokeLinecap: "round", strokeLinejoin: "round" } as const;

export const YouIcon = {
  archive: (
    <svg {...s}>
      <rect x="3.500" y="4.500" width="17" height="4.500" rx="1.500" />
      <path d="M5 9v8.500A2 2 0 0 0 7 19.500h10a2 2 0 0 0 2-2V9M10 13h4" />
    </svg>
  ),
  bell: (
    <svg {...s}>
      <path d="M6 16.5V11a6 6 0 1 1 12 0v5.5l1.5 1.5h-15L6 16.5ZM10 20.5a2 2 0 0 0 4 0" />
    </svg>
  ),
  moon: (
    <svg {...s}>
      <path d="M19.500 14.500A7.500 7.500 0 0 1 9.500 4.500a7.500 7.500 0 1 0 10 10Z" />
    </svg>
  ),
  shield: (
    <svg {...s}>
      <path d="M12 3.500 5.500 6v5.500c0 4 2.700 7 6.500 8.500 3.800-1.500 6.500-4.500 6.500-8.500V6L12 3.500Z" />
      <path d="m9 12 2.200 2.200L15.500 10" />
    </svg>
  ),
  skills: (
    <svg {...s}>
      <path d="M12 3.500 14 9l5.500 2-5.500 2-2 5.500L10 13l-5.500-2L10 9z" />
    </svg>
  ),
  gauge: (
    <svg {...s}>
      <path d="M4.500 16.500a7.500 7.500 0 1 1 15 0" />
      <path d="m12 16.500 3.500-5" />
    </svg>
  ),
  mic: (
    <svg {...s}>
      <rect x="9" y="3" width="6" height="11" rx="3" />
      <path d="M5.500 11.500a6.500 6.500 0 0 0 13 0M12 18v3" />
    </svg>
  ),
  laptop: (
    <svg {...s}>
      <rect x="4.5" y="5" width="15" height="10.5" rx="1.5" />
      <path d="M2.5 19h19" />
    </svg>
  ),
  help: (
    <svg {...s}>
      <circle cx="12" cy="12" r="9" />
      <path d="M9.6 9.4a2.5 2.5 0 1 1 3.6 2.2c-.8.4-1.2.9-1.2 1.9M12 16.8v.01" />
    </svg>
  ),
  signout: (
    <svg {...s}>
      <path d="M10 4.5H6.5a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2H10M15 8l4 4-4 4M19 12H9.5" />
    </svg>
  ),
  trash: (
    <svg {...s}>
      <path d="M4.5 7h15M9.5 7V4.5h5V7M6.5 7l.8 12.5h9.4L17.5 7M10 11v5M14 11v5" />
    </svg>
  ),
  chevron: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="m9.5 6 6 6-6 6" />
    </svg>
  ),
};

/** The rounded square an icon sits in at the start of a You row. */
export function Tile({ children }: { children: ReactNode }) {
  return (
    <span className="you-tile" aria-hidden>
      {children}
    </span>
  );
}

export const Chevron = () => (
  <span className="you-chev" aria-hidden>
    {YouIcon.chevron}
  </span>
);
